export const version = '%BUILDVERSION%';
export const env = 'prod';
